<script>
// api
import forEach from 'lodash/forEach'
import { resizeImage } from '~/util/img.util'
export default {
  props: {
    width: {
      default: 0,
      type: Number
    },
    images: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      isQQbrowser: /qqbrowser/.test(navigator.userAgent.toLowerCase()),
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      eva: '',
      itemHeight: '',
      itemWidth: '',
      imageList: [...this.images],
      previewList: [],
      resized: false,
      showPreviewVideo: false,
      previewViedoLink: '',
      showMore: false
    }
  },
  computed: {
    imgList() {
      if (!this.showMore) return this.imageList.slice(0, 9)
      return this.imageList
    }
  },
  watch: {
    images() {
      // this.imageList = this.images
      this.imageList = this.images
    }
  },

  created() {
    // alert(this.isQQbrowser)
  },
  methods: {
    itemWidthClass,
    resizeImage,
    onClickMore() {
      this.showMore = true
    },
    closePreviewImage() {
      this.showPreviewVideo = false
    },
    onClickMediaItem(media) {
      const { mediaType, resourceUrl, mediaResourceUrl } = media || {}

      if (mediaType === '3') {
        window.open(resourceUrl, '_blank')
      }

      if (mediaType === '2') {
        window.open(mediaResourceUrl, '_blank')
      }

      if (mediaType === '4') {
        this.previewViedoLink = resourceUrl
        this.showPreviewVideo = true
      }
    }
  }
}

function itemWidthClass() {
  const imageList = this.imageList
  let returnClass = ''
  if (imageList.length === 1) {
    this.itemWidth = this.width * 0.8
    this.itemHeight = ((this.width * 0.8) / 16) * 9
    returnClass = 'full_width_image'
  } else if (imageList.length === 2 || imageList.length === 4) {
    this.itemHeight = (this.width - 15) / 2
    this.itemWidth = this.itemHeight
    returnClass = 'double_width_image'
  } else {
    this.itemHeight = (this.width - 25) / 3
    this.itemWidth = this.itemHeight
    returnClass = 'more_width_image'
  }
  if (!this.resized) {
    const previewList = []
    forEach(this.imageList, (imageItem) => {
      previewList.push(imageItem.photoOssUrl)
      imageItem.photoOssUrl = resizeImage({
        src: imageItem.photoOssUrl,
        width: this.itemWidth,
        height: this.itemHeight
      })
    })
    this.previewList = previewList
    this.resized = true
  }
  return returnClass
}
</script>
<template>
  <div v-if="imageList.length > 0" class="img_grid_container">
    <div class="img_grid_item_container">
      <div class="img_grid_right_container">
        <div class="img_grid_image_container">
          <div
            v-for="(imageItem, index) in imgList"
            :key="imageItem.photoOssUrl"
          >
            <div
              :class="itemWidthClass(eva)"
              @click="onClickMediaItem(imageItem)"
              style="position:relative;cursor:pointer;"
            >
              <div v-show="imageItem.mediaType === '2'" class="tag">VR</div>
              <div v-show="imageItem.mediaType === '3'" class="tag">VR</div>
              <div v-show="imageItem.mediaType === '5'" class="tag">GIF</div>
              <div v-show="imageItem.mediaType === '4'" class="tag-video">
                <img src="./img/play.png" style="width:32px;height:32px;" />
              </div>

              <el-image
                v-if="
                  imageItem.mediaType === '1' || imageItem.mediaType === '5'
                "
                :style="{
                  height: itemHeight + 'px',
                  width: itemWidth + 'px'
                }"
                :preview-src-list="Array.of(previewList[index])"
                :src="imageItem.photoOssUrl"
                fit="fill"
              ></el-image>

              <img
                v-else
                :style="{
                  height: itemHeight + 'px',
                  width: itemWidth + 'px'
                }"
                :src="imageItem.photoOssUrl"
                fit="fill"
              />
            </div>

            <div
              @click="onClickMore"
              v-if="!showMore && index === 8 && imageList.length > 9"
              class="mask"
            >
              <span>+ {{ imageList.length - 9 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showPreviewVideo"
      :style="
        screenWidth > 940
          ? `background-color:rgba(0,0,0,0.5)`
          : `background-color:rgba(0,0,0,1)`
      "
      @click="closePreviewImage"
      class="el-dialog__wrapper preview_image_container"
    >
      <button
        @click="closePreviewImage"
        type="button"
        aria-label="Close"
        style="position: absolute;top:0px;right: 20px;z-index:1000;color:white"
        class="el-dialog__headerbtn"
      >
        <i class="el-icon-circle-close" style="color: white;font-size: 40px;" />
      </button>
      <div
        :style="
          screenWidth > 940
            ? `margin-top: 100px;width: 60%;margin: 0 auto;top: 5vh;`
            : `margin-top: 15vh;width: 100%;`
        "
        role="dialog"
        aria-modal="true"
        aria-label="dialog"
        class="el-dialog el-dialog-container"
      >
        <div style="padding: 0px;">
          <iframe
            v-if="isQQbrowser"
            :height="screenWidth > 940 ? 680 : screenHeight - 150"
            :src="previewViedoLink"
            style="width:100%;background-color:black;"
          />
          <video
            id="video"
            v-else
            :height="screenWidth > 940 ? 680 : screenHeight - 180"
            controls
            autoplay
            preload
            style="width:100%;background-color:black;"
          >
            <source :src="previewViedoLink" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.mask {
  position: absolute;
  top: 5px;
  right: 5px;
  left: 0px;
  bottom: 2px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: white;
    font-size: 28px;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
  }
}

.double_width_image {
  cursor: pointer;
}
.tag-video {
  position: absolute;
  left: 50%;
  top: calc(50% + 2px);
  transform: translate(-50%, -50%);
}

.el-dialog-container {
  position: relative;
  margin: 0 auto 50px;
  background: #fff;
  border-radius: 2px;
  box-sizing: border-box;
  width: 50%;
}
.el-dialog__header {
  padding: 20px 20px 10px;
}

:deep(.el-dialog__body) {
  padding-left: 30px;
  padding-right: 30px;
}
.preview_image_container {
  background: rgba(0, 0, 0, 0.5);
  z-index: 2005;
  overflow-y: hidden;
  touch-action: none;
}

.bottom_line_L_R_70 {
  position: relative;
}
.bottom_line_L_R_70::after {
  position: absolute;
  bottom: 0px;
  left: 70px;
  right: 0;
  display: block;
  background: #eff1f2;
  content: '';
  height: 1px;
  transform: scale(1, 0.5);
  -webkit-transform: scale(1, 0.5);
}

.img_grid_container {
  .img_grid_item_container {
    display: flex;
    position: relative;
    // padding-bottom: 25px;

    .img_grid_right_container {
      width: 100%;
      p {
        font-size: 16px;
        color: rgba(68, 68, 68, 1);
        line-height: 20px;
      }

      .img_grid_image_container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        $image_margin_top: 5px;
        $image_margin_right: 5px;
        > div {
          position: relative;
        }

        //3,5,6,7,8,9张图片
        .more_width_image {
          // width: 32%;
          margin-right: $image_margin_right;
          margin-top: $image_margin_top;
        }

        //1张图片
        .full_width_image {
          padding-top: 5px;
          // width: 100%;
        }

        //2张4张图片
        .double_width_image {
          // width: 49%;
          margin-right: $image_margin_right;
          margin-top: $image_margin_top;
        }
      }
    }
  }
}
@media screen and (min-width: 940px) {
  .el-dialog__body-container {
    padding-left: 64px;
    padding-right: 64px;
  }

  .tag {
    position: absolute;
    right: 10px;
    top: 15px;
    font-size: 16px;
    color: #ffffff;
    line-height: 16px;
    padding: 4px 10px !important;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 2px;
  }
}
@media screen and (max-width: 940px) {
  .mask {
    span {
      color: white;
      font-size: 22px;
      font-weight: 500;
    }
  }
  .tag {
    position: absolute;
    right: 5px;
    top: 10px;
    font-size: 12px;
    color: #ffffff;
    line-height: 16px;
    padding: 1px 5px !important;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
  }
  .img_grid_item_container {
    // padding-bottom: 15px !important;
  }
  .img_grid_container {
    width: 100%;
    padding: 0px 15px 0 0;
    .img_grid_item_container {
      .head_image {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
